import { GameAnswerState } from "../states/GamePageStates/GameAnswerState";
import { GameObjectValue } from "../states/GamePageStates/GameObjectValue";
import { AnswerStatus } from "../enums/AnswerStatus";

export const getAttemptWordCase = (count: number) => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;
  if (lastTwoDigits >= 10 && lastTwoDigits <= 19) {
    return "попыток";
  }
  if (lastDigit === 1) {
    return "попытку";
  }
  if (lastDigit >= 2 && lastDigit <= 4) {
    return "попытки";
  }
  return "попыток";
};

const _convertToEmoji = (gameObjectValue: GameObjectValue): string => {
  switch (gameObjectValue.answerStatus) {
    case AnswerStatus.Wrong:
      return "🟥";
    case AnswerStatus.WrongMore:
      return "🔼";
    case AnswerStatus.WrongLess:
      return "🔽";
    case AnswerStatus.PartiallyCorrect:
      return "🟨";
    case AnswerStatus.Correct:
      return "🟩";
  }
};

export const getEmojiRows = (gameAnswerStates: GameAnswerState[]): string[] => {
  return gameAnswerStates
    .map((gameAnswerState) => {
      let row = "";
      gameAnswerState.gameObjectValues.forEach((gameObjectValue) => {
        row += _convertToEmoji(gameObjectValue);
      });
      return row;
    })
    .reverse();
};
